import React from "react";
import Cta from "../cta/cta";

const TechnologyCta = () => {
  return (
    <Cta
      heading="Ready to transform your business with the latest technology?"
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default TechnologyCta;
